import { AUTHENTICATION_RESET_TYPE } from '../../constants/action_types';
import { defaultState } from './defaultState';
export function resetReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case AUTHENTICATION_RESET_TYPE:
      return defaultState;
  }
  return state;
}